import { useState } from "react";
import clsx from "clsx";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Input = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  onBlur,
  placeholder = "",
  error = "",
  hint = "",
  required = false,
  disabled = false,
  className = "",
  inputClassName = "",
  textarea = false,
  rows = 4,
  leftElement = null,
  rightElement = null,
  showPasswordToggle = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPasswordField = !textarea && type === "password";
  const shouldShowPasswordToggle = isPasswordField && showPasswordToggle;
  const resolvedType = shouldShowPasswordToggle
    ? showPassword
      ? "text"
      : "password"
    : type;

  const commonInputClasses = clsx(
    "w-full rounded-xl border bg-white px-4 py-3 text-sm text-[#2f2626] shadow-sm transition focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:bg-gray-100",
    error
      ? "border-red-400 focus:border-red-500 focus:ring-red-200"
      : "border-[#d7c2a3] focus:border-[#8B3A3A] focus:ring-[#ead8c0]",
    leftElement && "pl-11",
    (rightElement || shouldShowPasswordToggle) && "pr-11",
    inputClassName
  );

  const inputElement = textarea ? (
    <textarea
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      rows={rows}
      className={commonInputClasses}
      {...props}
    />
  ) : (
    <input
      id={name}
      name={name}
      type={resolvedType}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      className={commonInputClasses}
      {...props}
    />
  );

  return (
    <div className={clsx("w-full", className)}>
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block text-sm font-medium text-[#3b2f2f]"
        >
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        {leftElement && (
          <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-[#7a5c58]">
            {leftElement}
          </div>
        )}

        {inputElement}

        {shouldShowPasswordToggle ? (
          <button
            type="button"
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute inset-y-0 right-3 flex items-center text-[#7a5c58] transition hover:text-[#8B3A3A]"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
          </button>
        ) : rightElement ? (
          <div className="absolute inset-y-0 right-3 flex items-center text-[#7a5c58]">
            {rightElement}
          </div>
        ) : null}
      </div>

      {error ? (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      ) : hint ? (
        <p className="mt-2 text-sm text-[#6b5b57]">{hint}</p>
      ) : null}
    </div>
  );
};

export default Input;